import React, { useEffect, useMemo } from 'react';
import cn from 'classnames';
import { Typography } from 'seagull';
import { useStore, useStoreActions } from "../../../../contexts";
import styles from "./ActivityLogItem.module.scss";
import { timeModel } from "../../../../models";
import { getContent, getIcon } from "./ActivityLogItem.utils";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
import { selectors } from "../../../../store/state-selectors";
export default function ActivityLogItem(props) {
  const {
    entry,
    vendorName,
    clientName,
    relationship,
    isFirst,
    isLast
  } = props;
  const {
    logBI
  } = useStoreActions();
  const isVendor = useStore(selectors.user.isVendor);
  const {
    ORIGINAL_PROPOSAL
  } = useFeatureFlags();
  const testid = "activity-log-".concat(entry.id());
  const content = useMemo(() => {
    return getContent({
      entry,
      vendorName,
      clientName,
      isVendor,
      relationship,
      testid,
      logBI
    }, ORIGINAL_PROPOSAL);
  }, [entry, vendorName, clientName, relationship, testid, ORIGINAL_PROPOSAL, isVendor]);
  useEffect(() => {
    if (!content) {
      console.warn('Unrecognized activity-log entry', entry);
    }
  }, [content, entry]);
  return content ? /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.date
  }, /*#__PURE__*/React.createElement(Typography, null, timeModel.formatDateWithTime(entry.timestamp()))), /*#__PURE__*/React.createElement("div", {
    className: styles.separator
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.line, {
      [styles.transparent]: isFirst
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.dot
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.line, {
      [styles.transparent]: isLast
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.card
  }, /*#__PURE__*/React.createElement("span", null, getIcon(entry)), /*#__PURE__*/React.createElement(Typography, {
    className: styles.content,
    "data-testid": testid
  }, content))) : null;
}